export default __webpack_public_path__ + "static/media/vr.75010b49.svg";